import { Info, Megaphone, RefreshCw, Rocket, Sparkles, Tag, Wrench } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { CampaignType } from '@/lib/admin/messageCampaigns';

const ICONS: Record<CampaignType, LucideIcon> = {
  promotion: Tag,
  announcement: Megaphone,
  upgrade: Rocket,
  renewal: RefreshCw,
  informational: Info,
  feature_update: Sparkles,
  maintenance: Wrench,
  custom: Megaphone,
};

function campaignTypeIcon(type: CampaignType | string | null | undefined): LucideIcon {
  return ICONS[type as CampaignType] ?? Megaphone;
}

export function CampaignTypeIcon({
  type,
  className,
}: {
  type: CampaignType | string | null | undefined;
  className?: string;
}) {
  const Icon = campaignTypeIcon(type);
  return <Icon className={className} />;
}

export default CampaignTypeIcon;
